import { lifecycle, withHandlers, compose } from 'recompose';
import { connect } from 'react-redux';
import {
  getOutstanding,
  getTaxAmount,
  getTaxBreakdown,
  getTotalDiscounts,
  getTotalProducts,
  getTotalPromos,
  getTotalServices,
  getTotalMembershipDiscounts,
  getMembershipDiscounts,
} from '../../validated/selectors';
import ChargeModalSummary from '../components/ChargeModalSummary';
import { removePayment } from '../reducer/payments/actions';
import { getPayments } from '../reducer/payments/selectors';
import { resetPayments } from '../actions';

const ChargeModalSummaryContainer = compose(
  connect(
    state => ({
      servicesAmount: getTotalServices(state),
      productsAmount: getTotalProducts(state),
      taxAmount: getTaxAmount(state),
      discountAmount: getTotalDiscounts(state),
      membershipDiscountAmount: getTotalMembershipDiscounts(state),
      membershipDiscounts: getMembershipDiscounts(state),
      promoAmount: getTotalPromos(state),
      amountOwed: getOutstanding(state),
      paymentMethods: getPayments(state),
      taxBreakdown: getTaxBreakdown(state),
    }),
    { resetPayments, removePayment }
  ),
  withHandlers({
    removePayment: props => id => () => props.removePayment(id),
  }),
  lifecycle({
    componentDidMount() {
      this.props.resetPayments();
    },
  })
)(ChargeModalSummary);

export default ChargeModalSummaryContainer;
